import React from 'react';
import BaseType from './BaseType';

const CompanyAdded = ({ item }) => {
  return (
    <BaseType
      url={item.metadata?.known_org?.logo_url}
      name={item.metadata?.known_org?.name}
      tagType='neutral'
      tagText={
        <>
          Added to <b>{item?.metadata?.oagent.name}</b>
        </>
      }
      tagTo={`/campaign/${item?.metadata?.oagent?.id}`}
      time={item.time}
      isOrg
    />
  );
};

export default CompanyAdded;
